export default __webpack_public_path__ + "static/design-734bf34f0fc01407c90ac1f9c25d857c.jpg";